export default __webpack_public_path__ + "static/108-f1889aaffe8215a5f2340dddacdfe57a.gif";